
import { Vue } from "vue-property-decorator";
import _ from "lodash";

export default class AppVue extends Vue {

  get environment() {
    return process.env.VUE_APP_ENVIRONMENT;
  }

  get isDevEnv() {
    return this.environment === "Dev";
  }

  get isTestEnv() {
    return this.environment === "Test";
  }

  get isProdEnv() {
    return this.environment === "Production";
  }

}
